import { EditorOptions } from 'tinymce';

export const TinyMceTableEditorConfig: Partial<EditorOptions> = {
  base_url: '/tinymce',
  suffix: '.min',
  promotion: false,
  statusbar: false,
  menubar: false,
  toolbar: 'undo redo | bold italic underline strikethrough subscript superscript',
  toolbar_location: 'top',
  width: '100%',
  inline: true,
  object_resizing: false as never,
  table_resize_bars: false,
  table_sizing_mode: 'relative',
  paste_as_text: true
};
